

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const GET_USER_HOME = 'GET_USER_HOME';
export const GET_USER_HOME_SUCCESS = 'GET_USER_HOME_SUCCESS';

export const UPLOAD_IMG_REQUEST = 'UPLOAD_IMG_REQUEST';
export const UPLOAD_IMG_SUCCESS = 'UPLOAD_IMG_SUCCESS';
export const OPEN_MENU = 'OPEN_MENU';

export const GET_BANNER_HOME = 'GET_BANNER_HOME';
export const GET_BANNER_HOME_SUCCESS = 'GET_BANNER_HOME_SUCCESS';

export const GET_RECOMMEND_VIDEO = 'GET_RECOMMEND_VIDEO';
export const GET_RECOMMEND_VIDEO_SUCCESS = 'GET_RECOMMEND_VIDEO_SUCCESS';
